import $ from "jquery";

// Define the popup initialization function that will be called after Polylang is ready
window.initPopup = function(ajax_object) {
   // Check if ajax_object is defined
   if (typeof ajax_object === "undefined") {
       return;
   }

   // Cache DOM elements
   const popup = $("#popup");
   const closeBtn = $("#popupClose");

   // Ensure the popup and close button exist
   if (!popup.length || !closeBtn.length) {
       return;
   }

   // Function to check if a cookie exists
   function checkCookie(name) {
       return document.cookie.split(';').some(c => {
           return c.trim().startsWith(name + '=');
       });
   }

   // Simple function to set a cookie client-side (as a fallback)
   function setFallbackCookie(name, value, days) {
       const date = new Date();
       date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      
       // Basic cookie with no domain - most compatible approach
       document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/";
      
       // If we're on Pantheon, try with the current domain too
       if (window.location.hostname.indexOf('pantheonsite.io') > -1) {
           document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/;domain=" + window.location.hostname;
       }
   }

   // Check if the popup cookie exists
   if (!checkCookie('popup_status')) {
       // No cookie found, show the popup (with a slight delay for safety)
       setTimeout(() => {
           popup.fadeIn(300);
       }, 50);
   }

   // Handle close button click - hides popup and sets cookie via AJAX
   closeBtn.on("click", function () {
       // Hide the popup
       popup.fadeOut(300);

       // Send AJAX request to set server-side cookie via the WordPress AJAX handler
       $.ajax({
           url: ajax_object.ajaxurl,
           type: "POST",
           data: {
               action: "close_popup", // Calls handle_close_popup() in setup.php
               status: "closed"
           },
           // Set client-side cookie as fallback if AJAX fails
           error: function() {
               setFallbackCookie('popup_status', 'closed', 30);
           }
       });
      
       // Also set fallback cookie immediately (belt and suspenders approach)
       setFallbackCookie('popup_status', 'closed', 30);
   });

   // Also hide popup if ESC key is pressed
   $(document).keyup(function(e) {
       if (e.key === "Escape" && popup.is(":visible")) {
           closeBtn.trigger("click");
       }
   });
};

// Legacy initialization for backward compatibility
window.onload = function () {
    // Only run this if the popup wasn't already initialized
    if ($("#popup").length && typeof window.popupInitialized === 'undefined') {
        const ajax_object = window.ajax_object;
        
        if (typeof ajax_object !== 'undefined') {
            // Use a timeout to avoid race conditions with Polylang
            setTimeout(function() {
                if (typeof window.initPopup === 'function') {
                    window.initPopup(ajax_object);
                    window.popupInitialized = true;
                }
            }, 200);
        }
    }
};